/**
 * PRODUCT_DEV-396 ログイン後パスキー登録促進モーダル
 *
 * 表示条件は useLoginHandlers の `shouldShowPasskeyPrompt()` で判定される。
 * 通常: テナントが許可していて、未登録の場合に表示。OFFユーザは30日経過で再表示。
 * テスト: URL クエリ `?forcePasskeyPrompt=1` で常に表示、`=0` で常に非表示にできる。
 */
import { Fingerprint } from "lucide-react";

export const PasskeyPromptModal: React.FC<{
  loading: boolean;
  onSetup: () => void;
  onLater: () => void;
}> = ({ loading, onSetup, onLater }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6">
        <div className="flex flex-col items-center mb-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3">
            <Fingerprint className="w-8 h-8 text-primary" />
          </div>
          <h2 className="text-xl font-bold text-neutral-900">
            パスキーで安全にログイン
          </h2>
        </div>

        <p className="text-sm text-neutral-700 mb-6 text-center leading-relaxed">
          指紋認証や顔認証などの<strong>パスキー</strong>を登録すると、次回からよりスムーズに、より安全にログインできます。
        </p>

        <div className="space-y-3">
          <button
            type="button"
            onClick={onSetup}
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-4 bg-primary text-white text-base font-bold rounded-2xl hover:bg-primary/90 transition-colors disabled:opacity-50"
          >
            <Fingerprint className="w-5 h-5" />
            パスキーを設定する
          </button>
          <button
            type="button"
            onClick={onLater}
            disabled={loading}
            className="w-full py-3 text-sm text-neutral-600 hover:text-neutral-800 transition-colors disabled:opacity-50"
          >
            あとで（30日後にもう一度ご案内します）
          </button>
        </div>
      </div>
    </div>
  );
};
